import "./noteEnvelope.css";

/**
 * An envelope for a lesson note: outlined while the note has not reached the
 * family, filled once it has been sent.
 *
 * The shape is the same either way so the eye reads the fill, not the icon.
 * Always accompanied by a label for screen readers, since colour and fill on
 * their own say nothing to somebody who cannot see them.
 */
export function NoteEnvelope({
  sent,
  label,
  className,
}: {
  sent: boolean;
  label?: string;
  className?: string;
}) {
  const title = label ?? (sent ? "Note sent to family" : "Note not sent");
  return (
    <svg
      className={`note-envelope${sent ? " is-sent" : ""}${className ? ` ${className}` : ""}`}
      viewBox="0 0 24 24"
      width="18"
      height="18"
      role="img"
      aria-label={title}
      focusable="false"
    >
      <title>{title}</title>
      {sent ? (
        <>
          <path
            d="M3 6.5A1.5 1.5 0 0 1 4.5 5h15A1.5 1.5 0 0 1 21 6.5v.4l-9 5.6-9-5.6z"
            fill="currentColor"
          />
          <path
            d="M3 9.2V17.5A1.5 1.5 0 0 0 4.5 19h15a1.5 1.5 0 0 0 1.5-1.5V9.2l-9 5.6z"
            fill="currentColor"
          />
        </>
      ) : (
        <>
          <rect
            x="3.75"
            y="5.75"
            width="16.5"
            height="12.5"
            rx="1.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path
            d="M4.5 7l7.5 5 7.5-5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
        </>
      )}
    </svg>
  );
}
